import { View } from 'backbone.marionette';

import DocumentDownloadTypes from '@/enums/DocumentDownloadTypes';
import downloadDocument from '@/util/downloadDocument';
import formatAsDollars from '@/util/formatAsDollars';
import showErrorMessage from '@/util/showErrorMessage';

import tmplOrderDeviceItemView from './OrderDeviceItemView.hbs';
import './OrderDeviceItemView.css';

const OrderDeviceItemView = View.extend({
  template: tmplOrderDeviceItemView,

  className: 'order-device-item-view pt-2 pb-4 px-4',

  ui: {
    price: '.price',
    quantity: '.quantity',
    formattedTotalPrice: '.item-total-cost',
    image: 'img'
  },

  events: {
    'change @ui.quantity': 'onQuantityChange',
    'click @ui.image': 'downloadSpecSheet'
  },

  initialize() {
    // Initialize values and map for consistency
    this.model.set({
      productName: this.model.get('laserPrinterTonerCartridgeType') || this.model.get('model'),
      totalPrice: this.model.get('totalPrice') || '0',
      formattedTotalPrice: formatAsDollars(this.model.get('totalPrice') || 0),
      quantity: this.model.get('quantity') || '0'
    });
  },

  onQuantityChange(e) {
    const quantity = this.ui.quantity.val();
    const totalPrice = formatAsDollars(this.model.get('price') * quantity);
    this.ui.formattedTotalPrice.text(totalPrice);
    this.model.set('quantity', quantity);
    this.model.set('formattedTotalPrice', formatAsDollars(totalPrice));
  },

  async downloadSpecSheet(e) {
    const model = this.options?.model.get('model');
    const description = this.options?.model.get('description');
    try {
      await downloadDocument({
        attachmentId: this.options?.model.get('csDataSheetId'),
        downloadType: DocumentDownloadTypes.TEMPLATE,
        fileName: `${model || description || 'spec_sheet'}.pdf`
      });
    } catch (err) {
      if (err) {
        this.showDownloadError();
      }
    }
  },

  showDownloadError() {
    showErrorMessage({
      errorCode: 'downlaodError',
      errorTitle: 'Download Error',
      errorMessage:
        'An error occurred while downloading document. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default OrderDeviceItemView;
